import { firestore } from "firebase/app";
import TimeRange from "./TimeRange";
import { IresDevice } from "./IresDevice";
import { ProgramChain } from "./ProgramChain";

export enum IresDeviceAssignmetType {
  TESTING = "TESTING",
}

export interface DeviceAssignment {
  startDate: firestore.Timestamp;
  clientId: string;
  assignmentType: IresDeviceAssignmetType;

  currentProjectId: string | null;
  currentProjectName: string | null;
  currentProjectNumber: string | null;
  currentProjectResponsibleUserIds: string[] | null;
  currentProjectOwnerId: string | null;
  currentProjectSupervisorId: string | null;

  currentProjectBranch: null | string;
  currentProjectAssignmentTimeRange: null | TimeRange;

  deviceBranch: null | string;
  inventoryNumber: null | string;
}

export function doesProgramChainStartOnOrAfterCurrentProjectAssignmentStartDate(
  iresDevice: IresDevice,
  programChain: ProgramChain
) {
  const currentAssignment = iresDevice.currentAssignment;

  if (!currentAssignment) {
    return false;
  }

  const assignmentStartDate =
    currentAssignment?.currentProjectAssignmentTimeRange?.startDate;

  if (!assignmentStartDate) {
    return false;
  }

  return programChain.startDate.toMillis() >= assignmentStartDate.toMillis();
}

export function doesProgramChainStartBeforeCurrentProjectAssignmentStartDate(
  iresDevice: IresDevice,
  programChain: ProgramChain
) {
  return !doesProgramChainStartOnOrAfterCurrentProjectAssignmentStartDate(iresDevice, programChain);
}

export function hasDeviceAssignmentCurrentProject(
  deviceAssignment: DeviceAssignment | null | undefined
) {
  if (!deviceAssignment) {
    return false;
  }

  if (!deviceAssignment.currentProjectId) {
    return false;
  }

  if (deviceAssignment.currentProjectId == "") {
    return false;
  }

  return true;
}
